module.exports = __webpack_public_path__ + "img/ico_plus.023946e8.svg";